/**
 * @Author: ZLZ
 * @Date: 2025-12-29 14:54
 * @Description: 2.0 内容 高管持股 路由模块
 */
import Layout from "@/Layout";
export default [
  {
    path: "/gaoGuanChiGu",
    component: Layout,
    name: "GaoGuanChiGu",
    redirect: "/gaoGuanChiGu/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/gaoGuanChiGu/index.vue"),
        meta: {
          title: "高管持股",
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      },
      {
        path: 'ggcgSearch',
        component: () => import('@/views/gaoGuanChiGu/ggcgSearch.vue'),
        meta: {
          title: '高管持股',
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      },
      {
        path: 'stockDetailTable',
        component: () => import('@/views/gaoGuanChiGu/stockDetailTable.vue'),
        meta: {
          title: '高管持股',
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      },
      {
        path: 'personDetailTable',
        component: () => import('@/views/gaoGuanChiGu/personDetailTable.vue'),
        meta: {
          title: '高管持股',
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      }
    ]
  },
];
